
import {
  Document,
  Page,
  Text,
  Image,
  View,
  StyleSheet,
  PDFDownloadLink,
} from '@react-pdf/renderer';
import Html from 'react-pdf-html';
import { pdf } from '@react-pdf/renderer';
import { title } from 'process';



/*======================= Style Page ===========================*/
const px = (value: number) => value * 0.75;

const styles = StyleSheet.create({
  page: {
    padding: 40,
    paddingBottom: 50,
    fontSize: 12,
  },
  paragraph: {
    marginBottom: 10,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 10,
    color: 'grey',
  },
});

const stylesStep1 = StyleSheet.create({
    page: {
        padding: 40,
        fontSize: 12,
    },
    titleImage : {
        width:px(200),
        height:px(200),
        maxHeight: 205,
        objectFit: "contain"
    },
    estimateName: {
        fontWeight: 700,
        fontSize: px(32),
        lineHeight: 1.5,
        // letterSpacing: "0%",
        textAlign: "center",
        color: "#393B3E",
        marginBottom: 10,
    },
    estimateCompany : {
        fontWeight: 600,
        fontSize: px(24),
        lineHeight: 1.5,
        textAlign: "center",
        color: "#2D80FC",
    },
    estimateCompanyHelp : {
        fontWeight: 400,
        fontSize: px(16),
        lineHeight: 1.5,
        textAlign: "center",
        color: "#949699",
    },
    estimateInfo : {
        marginTop: px(40),
        border: "1px solid #E5E7EB",
        borderRadius: px(12),
        paddingTop: px(31),
        paddingBottom: px(31),
        paddingLeft: px(154),
        paddingRight: px(154),
        display: "flex",
        flexDirection: 'row',
        gap: px(40),
    },
    infoBox:{
        width: px(230),
    },
    infoBoxH3 : {
        fontWeight: 600,
        fontSize: px(20),
        lineHeight: 1.5,
        color: "#393B3E",
        marginBottom: px(8),
    },
    infoBoxP : {
        fontWeight: 400,
        fontSize: px(14),
        lineHeight: 1.5,
        color: "#949699",
    },
    who :{
        marginTop: px(40),
    },
    whoH2 : {
        fontWeight: 700,
        fontSize: px(28),
        lineHeight: 1.5,
        color: "#393B3E",
    },
    achievements :{
        display: "flex",
        flexDirection: 'row',
        gap:px(23),
        marginTop: px(25),
        
    },
    achievement : {
        width: px(215),
        height: px(105),
        borderRadius: px(8),
        backgroundColor : "#F1F4F9",

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    achievementH3 : {
        fontWeight: 700,
        fontSize: px(24),
        lineHeight: 1.5,
        color: "#2D80FC",
    },
    achievementH4 : {
        fontWeight: 600,
        fontSize: px(14),
        lineHeight: 1.5,
        color: "#393B3E",
    },
    ourServices : {
        marginTop: px(25),
    },
    ourServicesH3 : {
        fontWeight: 600,
        fontSize: px(20),
        lineHeight: 1.5,
    },
    ul: {
        marginLeft: 12,
        color:'393B3E',
        fontWeight: 400,
        fontSize: px(16),
        lineHeight: 1.5,
    },
    li: {
        flexDirection: 'row',
        marginBottom: 4,
    },
    bullet: {
        width: 10,
    },
    liText: {
        flex: 1,
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: 'grey',
    },
});

const stylesStep2 = StyleSheet.create({
    quoteHeader : {
        fontSize: px(32),
        fontWeight: 700,
        color: "#2D80FC",
        marginottom: px(40),
    },
    quoteList : {
        width: "100%",
        marginTop: px(40),
    },
    quote : {
        paddingTop: px(4),
        paddingBottom: px(4),
        paddingLeft: px(16),
        paddingRight: px(16),
    },
    quoteGray:{
        backgroundColor:"#cccccc",
    },
    quoteTitle:{
        fontSize: px(18),
        fontWeight: 700,
        height: px(30),
    },
    quoteSection:{
        fontSize: px(16),
        fontWeight: 600,
        height: px(30),
    },
    quoteP: {
        height: px(20),
    },
    total:{
        marginTop: px(20),
        marginBottom: px(40)
    },
    totalRow: {
        display:"flex",
        flexDirection: 'row',
        alignItems:"center",
        gap:px(12),
        justifyContent:"flex-end"

    },
    totalRowLeft:{
        fontSize: px(16),
        fontWeight: 600,
        width: px(200),
        textAlign: "right"
    },
    totalRowRight:{
        fontSize: px(16),
        fontWeight: 400,
        width: px(100),
        textAlign: "right"
    },
})

const stylesStep5 = StyleSheet.create({
    quoteHeader : {
        fontSize: px(32),
        fontWeight: 700,
        color: "#2D80FC",
        marginottom: px(40),
    },
    sectionList : {
        width: "100%",
        marginTop: px(40),
    },
    sectionHeader : {
        display: "flex",
        flexDirection: 'row',
        alignItems: "center",
        backgroundColor: "#cccccc",
        paddingTop: px(5),
        paddingBottom: px(5),
        paddingLeft: px(10),
        fontSize: px(16),
        fontWeight: 700,
    },
    sectionListTitle : {
        fontSize: px(16),
        fontWeight: 700,
    },
    sectionHeaderDescription : {
        width: "70%",
    },
    sectionHeaderLine : {
        width: "30%",
    },
    sectionItem :{ 
        width: "100%",
        display: "flex",
        flexDirection: 'row',
        alignItems: "center",
        paddingTop: px(5),
        paddingBottom: px(5),
        paddingLeft: px(10),
    },
    sectionGray : {
        backgroundColor: "#cccccc",
    },
    sectionItemTitle : {
        fontSize: px(16),
        fontWeight: 400,
    },
    quote : {
        paddingTop: px(4),
        paddingBottom: px(4),
        paddingLeft: px(16),
        paddingRight: px(16),
    },
    quoteGray:{
        backgroundColor:"#cccccc",
    },
    quoteTitle:{
        fontSize: px(18),
        fontWeight: 700,
    },
    quoteSection:{
        fontSize: px(16),
        fontWeight: 500,
    },
})

const stylesStep6 = StyleSheet.create({
    quoteHeader : {
        fontSize: px(32),
        fontWeight: 700,
        color: "#2D80FC",
        marginottom: px(40),
    },
    viewHtml : {
        marginTop: px(40),
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        right: 20,
        textAlign: 'right',
       
        fontSize: 10,
        color: 'grey',
        backgroundColor: "#cccccc",
    },
    acknowledge : {
        border: "1px solid #ff0000",
        color: "#000000",
        fontWeight: 600,
        paddingTop: px(8),
        paddingBottom: px(8),
        paddingLeft: px(6),
        paddingRight: px(16),
    }
})

const stylesStep7 = StyleSheet.create({
    quoteHeader : {
        fontSize: px(32),
        fontWeight: 700,
        color: "#2D80FC",
        marginottom: px(40),
    },
    viewHtml : {
        marginTop: px(40),
    }
})


const styleHtml =`
<style>
    p {
        font-size: 13px;
        line-height: 1.2;
    }
    .ql-size-huge {
        font-size: 24.5px;
        line-height: 1.2;
    }
    .ql-size-large {
        font-size: 19.5px;
    }
    .ql-size-small {
        font-size: 9.75px;
    }
</style>
`

/*======================= Convert Data Page ===========================*/

const convertDateToString = (date:Date) => {
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric"
    }).toUpperCase();
}

const contentHtml = (html?: string) => {
    return `${html ?? ''} ${styleHtml}`
}

const getQuoteArrayString = (quotes:any[]) =>{
    let rowString:{label:string, type:string}[] = []
    rowString.push( {label : 'Description', type:"title" });

    (quotes ?? []).map(quote=>{
        if(quote && !quote.isVisible) return

        rowString.push( {label : quote?.title ?? '', type:"title-section" });

        (quote?.sectionItems ?? []).map((section:any) => {
            rowString.push( {label : section?.itemName ?? '', type:"section" });
        })
    })

    return rowString;
}

const getOptional = (optional:any) =>{
    return optional && optional.sections ? optional.sections : [];
}



/*======================= Content Page ===========================*/
const PageStep1 = (data:any, imageUrl:string) => {
    return(
        <Page size="A4" style={styles.page}>
            <Image
                src={imageUrl}
                style={stylesStep1.titleImage}
            />
            <Text style={stylesStep1.estimateName}>
                {data.name}
            </Text>
            <Text style={stylesStep1.estimateCompany}>
                {data.companyName}
            </Text>
            <Text style={stylesStep1.estimateCompanyHelp}>
                Comprehensive roofing services for your property
            </Text>

            <View style={stylesStep1.estimateInfo}>
                <View style={stylesStep1.infoBox}>
                    <Text style={stylesStep1.infoBoxH3}>
                       Prepared For:
                    </Text>

                    <Text style={stylesStep1.infoBoxP}>
                       {data.firstName} {data.firstName}
                    </Text>
                    <Text style={stylesStep1.infoBoxP}>
                       {data.address}
                    </Text>
                    <Text style={stylesStep1.infoBoxP}>
                       {data.stateProvince}, {data.city}
                    </Text>
                </View>
                <View style={stylesStep1.infoBox}>
                    <Text style={stylesStep1.infoBoxH3}>
                       Estimate Date:
                    </Text>

                    <Text style={stylesStep1.infoBoxP}>
                       {convertDateToString(data.estimateDate ? new Date(data.estimateDate) : new Date()) }
                    </Text>
                    <Text style={stylesStep1.infoBoxP}>
                       Valid for 30 days
                    </Text>
                    <Text style={stylesStep1.infoBoxP}>
                       {data.province}, {data.zipCodePostalCode}
                    </Text>
                </View>
            </View>

            <View style={stylesStep1.who}>
                <Text style={stylesStep1.whoH2}>
                    {data.titleStep2}
                    {/* WHO WE ARE */}
                </Text>
                <Html>{contentHtml(data.usDescription)}</Html>

                 <View style={stylesStep1.achievements}>
                    <View style={stylesStep1.achievement}>
                        <Text style={stylesStep1.achievementH3}>
                            15+
                        </Text>

                        <Text style={stylesStep1.achievementH4}>
                            Years Experience
                        </Text>
                    </View>
                    <View style={stylesStep1.achievement}>
                        <Text style={stylesStep1.achievementH3}>
                            100%
                        </Text>

                        <Text style={stylesStep1.achievementH4}>
                            Licensed & Insured
                        </Text>
                    </View>
                    <View style={stylesStep1.achievement}>
                        <Text style={stylesStep1.achievementH3}>
                            500+
                        </Text>

                        <Text style={stylesStep1.achievementH4}>
                            Satisfied Customers
                        </Text>
                    </View>

                 </View>
            </View>


            <View style={stylesStep1.ourServices}>
                <Text style={stylesStep1.ourServicesH3}>
                    Our Services
                </Text>
                <View style={stylesStep1.li}>
                    <Text style={stylesStep1.bullet}>•</Text>
                    <Text style={stylesStep1.liText}>Complete roof replacement and installation</Text>
                </View>

                <View style={stylesStep1.li}>
                    <Text style={stylesStep1.bullet}>•</Text>
                    <Text style={stylesStep1.liText}>Complete roof replacement and installation 2</Text>
                </View>
            </View>
        </Page>
    )
    
}


const PageStep4 = (data:any) => {
    const quotes = data?.quotes ?? [];
    return(
        <Page size="A4" style={styles.page}>
            <Text style={stylesStep2.quoteHeader}>
                OWENS CORNING ROOF SYSTEM
            </Text>

            {
                quotes.map((quote:any)=>{
                    const sections = quote?.sections ?? [];
                    let _mainTotal = 0;
                    sections.map((section:any) => {
                        const sectionItems = section?.sectionItems ?? [];
                        sectionItems.map((sectionItem:any)=>{
                            _mainTotal += (sectionItem.quantity ?? 0) * (sectionItem.unitPrice ?? 0)
                        })
                    })

                    let progress = quote.quoteProfitMargin;
                    if(!progress) progress = 0
                    if(progress < 0.27) progress = 0.27;
                    if(progress > 0.99) progress = 0.99;
                    let _material = _mainTotal*0.67;
                    let _total = _material/(1-progress);

                    return (
                        <>
                            <View style={stylesStep2.quoteList}>
                            {
                                getQuoteArrayString(sections).map((item, index)=>(
                                    <View style={{...stylesStep2.quote,
                                        ...(index % 2 == 0 ? stylesStep2.quoteGray : {}),
                                        ...(item.type == 'title' ? stylesStep2.quoteTitle : {}),
                                        ...(item.type == 'title-section' ? stylesStep2.quoteSection : {}),
                                    }}>
                                        <Text style={stylesStep2.quoteP}>
                                            {item.label}
                                        </Text>
                                    </View>
                                ))
                            }
                            </View>

                            <View style={stylesStep2.total}>
                                <View style={stylesStep2.totalRow}>
                                    <Text style={stylesStep2.totalRowLeft}>
                                        Estimate subtotal
                                    </Text>
                                    <Text style={stylesStep2.totalRowRight}>
                                        ${_total.toFixed(2)}
                                    </Text>
                                </View>
                                <View style={stylesStep2.totalRow}>
                                    <Text style={stylesStep2.totalRowLeft}>
                                        Total
                                    </Text>
                                    <Text style={stylesStep2.totalRowRight}>
                                        ${_total.toFixed(2)}
                                    </Text>
                                </View>
                            </View>
                        </>
                    
                ) })
            }

            {

            }
{/* 
            <View style={stylesStep2.quoteList}>
            {
                getQuoteArrayString(data.quotes).map((item, index)=>(
                    <View style={{...stylesStep2.quote,
                        ...(index % 2 == 0 ? stylesStep2.quoteGray : {}),
                        ...(item.type == 'title' ? stylesStep2.quoteTitle : {}),
                        ...(item.type == 'title-section' ? stylesStep2.quoteSection : {}),
                     }}>
                        <Text>
                            {item.label}
                        </Text>
                    </View>
                    // <div className={cx({
                    //     quote: true,
                    //     "gray": index % 2 == 0,
                    //     'title': item.type == 'title',
                    //     'title-section': item.type == 'title-section'
                    // })}>{item.label}</div>
                ))
            }
            </View> */}


        </Page>
    )
}

const PageStep5 = (data:any) => {
    return(
        <Page size="A4" style={styles.page}>
            <Text style={stylesStep5.quoteHeader}>
                AUTHORIZATION PAGE
            </Text>

            
            <View style={stylesStep5.sectionList}>
                <View style={stylesStep5.sectionHeader}>
                    <View style={stylesStep5.sectionHeaderDescription}>
                        <Text style={stylesStep5.sectionListTitle}>
                            Description
                        </Text>
                    </View>
                    <View style={stylesStep5.sectionHeaderLine}>
                        <Text style={stylesStep5.sectionListTitle}>
                            Line total
                        </Text>
                    </View>
                </View>
                
            {
                getOptional(data.optional).map((item:any, index:number)=>(
                    <View style={{...stylesStep5.sectionItem,
                        ...(
                           index % 2 == 1 ? stylesStep5.sectionGray : {}
                        )}}>
                        <View style={stylesStep5.sectionHeaderDescription}>
                            <Text style={stylesStep5.sectionItemTitle}>
                                {item.itemName}
                            </Text>
                        </View>
                        <View style={stylesStep5.sectionHeaderLine}>
                            <Text style={stylesStep5.sectionItemTitle}>
                                ${(item.unitPrice * item.quantity).toFixed(2)}
                            </Text>
                        </View>
                    </View>
                    // <div className={cx({
                    //     quote: true,
                    //     "gray": index % 2 == 0,
                    //     'title': item.type == 'title',
                    //     'title-section': item.type == 'title-section'
                    // })}>{item.label}</div>
                ))
            }
            </View>
        </Page>
    )
}

const PageStep6 = (data:any) => {
    return(
        <Page size="A4" style={styles.page}>
            <Text style={stylesStep6.quoteHeader}>
                TERMS AND CONDITIONS
            </Text>

            <View style={stylesStep6.viewHtml}>
                <Html>{contentHtml(data?.termsNConditions)}</Html>
            </View>

            <View
                style={stylesStep6.footer}
                fixed
                render={({ pageNumber }) =>
                (
                    <View style={stylesStep6.acknowledge}>
                        <Text>I acknowledge that I have read and understand this page. Initials:_________________________</Text>
                    </View>
                )
                }
            />
        </Page>
    )
}

const PageStep7 = (data:any) => {
    return(
        <Page size="A4" style={styles.page}>
            <Text style={stylesStep6.quoteHeader}>
                CBR INSURANCE
            </Text>

            <View style={stylesStep6.viewHtml}>
                <Html>{contentHtml(data?.insuranceDetails)}</Html>
            </View>
        </Page>
    )
}

/*======================= Content Document ===========================*/
const EstimatePDFExport = ({ data , imageUrl}:{data:any, imageUrl:string}) => {
    return(
        <Document>
            {PageStep1(data,imageUrl )}

            {PageStep4(data)}

            {PageStep5(data)}

            {PageStep6(data)}

            {PageStep7(data)}
            

            {/* Footer */}
            {/* <Text
                style={styles.footer}
                fixed
                render={({ pageNumber, totalPages }) =>
                `Trang ${pageNumber} / ${totalPages}`
                }
            /> */}

        </Document>
    )
        
}


/*======================= Content Document ===========================*/
const EstimatePDFExportStep = ({ data, step, imageUrl}:{data:any, step:number, imageUrl:string}) => {
    return(
        <Document>
            {(step == 0 || step == 2) && PageStep1(data,imageUrl )}

            {step == 3 && PageStep4(data)}

            {step == 4 && PageStep5(data)}

            {step == 5 && PageStep6(data)}

            {step == 6 && PageStep7(data)}
            

            {/* Footer */}
            {/* <Text
                style={styles.footer}
                fixed
                render={({ pageNumber, totalPages }) =>
                `Trang ${pageNumber} / ${totalPages}`
                }
            /> */}

        </Document>
    )
        
}


/**============ Load =================*/

function preloadImage(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => resolve(url);
    img.onerror = reject;
    img.src = url;
  });
}

function waitImageLoaded(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('Image load failed'));
    img.src = src;
  });
}

export async function generateSectionPdf(data:any) {

    let imageTest = "https://aps-s3-dev.s3.amazonaws.com/1767755876152_Screenshot%202025-12-23%20at%2016.35.41.png";
    await waitImageLoaded(imageTest);

    const instance = pdf();
    instance.updateContainer(EstimatePDFExport({
        data:data,
        imageUrl:imageTest
    }));
    //const blob = await instance.toBlob();
    const blob = await pdf(<EstimatePDFExport data={data} imageUrl={imageTest}/>).toBlob();
    return blob;
 // return await blob.arrayBuffer();
}

export async function generateSectionPdfByStep(data:any, step:number) {

    let imageTest = "https://aps-s3-dev.s3.amazonaws.com/1767755876152_Screenshot%202025-12-23%20at%2016.35.41.png";
    await waitImageLoaded(imageTest);

    const instance = pdf();
    instance.updateContainer(EstimatePDFExport({
        data:data,
        imageUrl:imageTest
    }));
    //const blob = await instance.toBlob();
    const blob = await pdf(<EstimatePDFExportStep data={data} step={step} imageUrl={imageTest}/>).toBlob();
    return blob;
 // return await blob.arrayBuffer();
}

